import { EmployeeAccessTypes, LanguageTypes } from '../enums';

export interface Employee {
  $id?: string;
  EmployeeId: number;
  NameFirst: string;
  NameLast: string;
  EmailAddress?: string;
  PhoneNumber?: string;
  AccessType?: EmployeeAccessTypes;
  LanguageType?: LanguageTypes;
  LocationIds?: number[];
  Pin?: string | null;
}
